<template>
  <el-card style="border-radius: 8px;margin-top: 30px" :body-style="{padding:'0px'}">
    <div class="main_content">
      <div class="transBak"></div>
      <div style="margin-left: 200px;width: 265px;position: relative;z-index: 2">
        <img style="height: 490px;" src="../../common/imgs/appxiazai_moxing.png">
        <video class="video_media" autoplay="autoplay"
               src="http://1251323988.vod2.myqcloud.com/91980d69vodgzp1251323988/7d8c8fe99031868222977230771/f0.mp4"
               controls="controls">
        </video>
      </div>
      <div style="width: 100%;margin-top: 25px;display: flex;flex-direction: column;align-items: center;z-index: 2">
        <img style="margin-top: 40px" src="../../common/images/logo.png">
        <a style="font-size: 20px;margin-top: 20px;color: #FFEBCD">公考一站式在线服务平台</a>
        <div style="display: flex;flex-direction: row;margin-top: 50px">
          <div class="code_content">
            <div class="code_title">
              <img width="20px" height="20px" style="margin-right: 5px" src="../../common/images/mini.png">
              <a style="color: #333333">小程序</a>
            </div>
            <img class="code_img" src="../../common/images/wx_miniprogram.jpeg">
          </div>
          <div style="width: 20px"/>
          <div class="code_content">
            <div class="code_title">
              <img width="20px" height="20px" style="margin-right: 5px" src="../../common/images/android.png">
              <a style="color: #333333">安卓</a>
            </div>
            <img class="code_img" src="../../common/images/downloadurl.png">
          </div>
          <div style="width: 20px"/>
          <div class="code_content">
            <div class="code_title">
              <img width="20px" height="20px" style="margin-right: 5px" src="../../common/images/ios.png">
              <a style="color: #333333">苹果</a>
            </div>
            <img class="code_img" src="../../common/images/appstore.png">
          </div>
        </div>
      </div>
    </div>
  </el-card>


  <!--      <map name="mymap">-->
  <!--        <area id="ios" shape="rect" href="https://itunes.apple.com/cn/app/%E5%BF%85%E8%83%9C%E5%85%AC%E8%80%83-%E5%85%AC%E5%8A%A1%E5%91%98%E8%80%83%E8%AF%95%E7%9C%9F%E9%A2%98%E5%92%8C%E8%A7%86%E9%A2%91%E7%B2%BE%E8%AE%B2%E7%A5%9E%E5%99%A8/id1126730430?mt=8" coords="&quot;1175,249,1028,285&quot;">-->
  <!--        <area id="android" shape="rect" href="http://a.app.qq.com/o/simple.jsp?pkgname=gwy.winlesson.app" coords="&quot;960,249,813,285&quot;">-->
  <!--      </map>-->
</template>

<script>
export default {
  name: 'download',
}
</script>

<style scoped>

.main_content {
  height: 100%;
  display: flex;
  padding-top: 50px;
  padding-bottom: 50px;
  flex-direction: row;
  background-image: url("../../common/images/bak04.jpeg");
  position: relative;
}

.video_media {
  position: absolute;
  left: 20px;
  top: 0;
  height: 100%;
  width: 196px;
}

.code_content {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.code_title {
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #ffffff;
  width: 175px;
  justify-content: center;
  padding-top: 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.code_img {
  width: 175px;
  height: auto;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.transBak {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/downLoad.vue